import angular from 'angular';

angular
  .module('cxInvoicing')
  .controller('EditInvoiceDialogCtrl', [
    '$element',
    '$timeout',
    'flySvc',
    'resourceFactorySvc',
    'dataCache',
    '$translate',
    'close',
    'invoice',
    editInvoiceDialogCtrl,
  ]);

function editInvoiceDialogCtrl(
  $element,
  $timeout,
  flySvc,
  resourceFactorySvc,
  dataCache,
  $translate,
  close,
  invoice,
) {
  var vm = this;
  var invoiceResource = resourceFactorySvc.get('invoice');
  vm.invoice = invoice;
  vm.editingCustomer = false;
  vm.saving = false;
  vm.customer = null;
  vm.isMasterTenant = dataCache.getArray('isMasterTenant');

  var showError = function(error) {
    vm.saving = false;
    flySvc.error(error.data.code, error.data.parameters);
  };

  vm.editCustomer = function() {
    if (!vm.customer || vm.customer.id !== vm.invoice.customer.id)
      vm.customer = vm.invoice.customer;
    vm.editingCustomer = true;
  };

  vm.customerChanged = function(customer) {
    if (customer == null) {
      vm.editingCustomer = false;
      return;
    }
    invoiceResource.update(
      {},
      angular.extend({}, vm.invoice, {
        customer: customer,
      }),
      function() {
        vm.invoice.customer = customer;
        vm.editingCustomer = false;
      },
      showError,
    );
  };

  vm.updateInvoice = function(value, property) {
    vm.invoice[property] = value;
    invoiceResource.update({}, angular.extend({}, vm.invoice), function() {}, showError);
  };
  vm.getErrorMsg = flySvc.getErrorMsg;

  vm.save = function(send) {
    vm.saving = true;
    $timeout(function() {
      invoiceResource.commitEdit(
        {
          id2: vm.invoice.id,
          sendMail: send,
        },
        function() {
          $element.modal('hide');
          close(vm.invoice.id, 500);
        },
        showError,
      );
    }, 0);
  };
  vm.cancel = function() {
    $timeout(function() {
      invoiceResource.cancelEdit(
        {
          id2: vm.invoice.id,
        },
        function() {
          close(null, 500);
        },
        showError,
      );
    }, 100);
  };
}
